import { gql } from '@apollo/client';

export const UPDATE_MAPPING = gql`
  mutation updateMapping($data: MappingInput!) {
    updateMapping(data: $data) {
      __typename
    }
  }
`;
